const moduleName = 'ytVideo';

export function ytVideo() {

    const ytScriptUrl = 'https://www.youtube.com/iframe_api';

    if (!document.querySelector(`script[src="${ytScriptUrl}"]`)) {
        const scriptElement = document.createElement('script');
        const firstScriptElement = document.getElementsByTagName("script")[0];

        scriptElement.src = ytScriptUrl;
        firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
    }

    Array.from(document.querySelectorAll('.js-yt-video')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const holder = self;
        const button = holder.querySelector('.js-yt-video-button');
        const player = holder.querySelector('.js-yt-video-iframe');
        const id = holder.getAttribute('data-id');

        button.addEventListener('click', (event) => {
            event.preventDefault();
            playVideo();
        });



        function playVideo() {
            const ytplayer = new YT.Player(player, {
                playerVars: {
                    'autoplay': 0,
                    'modestbranding': 1,
                    'rel': 0
                },
                videoId: id,
                events: {
                    onReady: () => {
                        ytplayer.playVideo();
                        holder.classList.add('_active');
                    }
                }
            });
        }
    });

}